import React from "react";
import LiveTesting from "./LiveTesting";

// The Live Trading tab = the live-TRADER box (prod, shadow mode for now).
// Same UI as Live Testing, backed by /api/live_trading -> schema
// intraday_trading (live_preds / live_trades / its own live_config). Knob and
// model-version writes here re-tune ONLY the trader box; the tester's config
// is untouched (and vice versa).
const LiveTrading = ({ darkMode }) => (
  <LiveTesting
    darkMode={darkMode}
    apiBase="/live_trading"
    serviceControl
    serviceSuspend
    ackControl
    approveOnSave
    title="Live Trading"
    subtitle="Live-trader box — own schema, own config, own model-version picks. Execution mode (paper / armed / mirror / live) and the pre-trade envelope are in the Control Panel."
  />
);

export default LiveTrading;
